<template>
    <ModalContainer>
        <div class="relative bg-white rounded-lg shadow p-4">
            <div class="flex items-start justify-between p-4 border-b rounded-t">
                <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
                    Text Element
                </h3>
                <button type="button"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center" @click="close">
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
            <!-- Modal body -->
            <div class="p-6 space-y-6">
                <div class="mb-3">
                    <InputGroup type="text" label="Text" v-model="value" />
                </div>
            </div>
            <!-- Modal footer -->
            <div class="flex justify-end p-6 space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600">
                <ButtonPrimary @click="insertText">Insert</ButtonPrimary>
            </div>
        </div>
    </ModalContainer>
</template>
<script>
import ModalContainer from '../../../components/modal/ModalContainer';
export default {
    props: {
        action: {},
        closeAction: {},
    },

    components: {
        ModalContainer,
    },

    data() {
        return {
            value: '',
        };
    },

    methods: {
        insertText() {
            if (this.value.length === 0) {
                return;
            }

            this.action('text', this.value);
            this.close();
        },

        close() {
            this.closeAction();
        }
    }
}
</script>